import { DeviceApiError, PairingSessionRefreshError } from '@ghostscreen/player-core';

function isRefreshNamedError(error: unknown): boolean {
  if (typeof PairingSessionRefreshError === 'function' && error instanceof PairingSessionRefreshError) {
    return true;
  }
  return error instanceof Error && error.name === 'PairingSessionRefreshError';
}

/**
 * Safety-net errors where the TV should mint a new QR silently
 * (timer-based rotate is the primary path; this covers sleep/clock skew).
 */
export function isPairingAutoRefreshError(error: unknown): boolean {
  if (isRefreshNamedError(error)) return true;
  if (error instanceof DeviceApiError) {
    if (error.status === 404) return true;
    if (error.status >= 500) return true;
  }
  if (error instanceof TypeError) return true;
  if (error instanceof Error) {
    const message = error.message.toLowerCase();
    if (message.includes('failed to fetch')) return true;
    if (message.includes('network')) return true;
  }
  return false;
}
